import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Organization, User, UserResponse } from '../models/user.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
      private apiUrl = `${environment.apiUrl}/api/users`;

      constructor(private http: HttpClient) { }

      getUsers(pageIndex: number, pageSize: number, query?: string): Observable<UserResponse> {
            let params = new HttpParams()
                  .set('pageIndex', pageIndex.toString())
                  .set('pageSize', pageSize.toString());
            if (query) params = params.set('q', query);
            return this.http.get<UserResponse>(this.apiUrl, { params });
      }

      // user.service.ts


      create(user: User): Observable<User> {
            return this.http.post<User>(this.apiUrl, user);
      }

      update(id: string, user: User): Observable<User> {
            return this.http.put<User>(`${this.apiUrl}/${id}`, user);
      }

      delete(id: string): Observable<any> {
            return this.http.delete(`${this.apiUrl}/${id}`);
      }
}